
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"10","fill":"none"}},[_c('path',{attrs:{"fill":"#5A5A5A","d":"M6.99.632a.499.499 0 10-.676.736L6.99.632zM11 5l.338.368a.5.5 0 000-.736L11 5zM6.314 8.632a.5.5 0 10.677.736l-.677-.736zM1 4.5a.5.5 0 000 1v-1zm5.314-3.132l4.348 4 .676-.736-4.347-4-.677.736zm4.348 3.264l-4.348 4 .677.736 4.348-4-.678-.736zM11 4.5H1v1h10v-1z"}})])
      }
    
      }
    